export class PaymentPass {
	constructor(data) {
		this.id = data?.id || 0;
		this.passId = data?.passId || 0;
		this.passProgramId = data?.passProgramId || 0;
		this.transactionId = data?.transactionId || 0;
		this.pass = null;
	}
}